<template>
  <v-container
    v-if="user === null"
    fluid
    text-xs-center
    fill-height
    align-center
    style="padding:0; margin: 0;"
  >
    <v-layout
      :style="heightOverflow + 'width: 100vw'"
      align-center
      justify-center>
      <v-container
        grid-list-md
        align-center
        text-xs-center>
        <v-layout
          fill-height
          row
          wrap
          pt-4
          mt-4
          justify-space-between
          align-center
        >
          <v-flex sm12 md6>
            <LeftLogo/>
          </v-flex>
          
          <v-spacer/>
          <v-flex
            
            md6
            xs12
            sm12
            class="login-content"
            align-self-center>
            <v-spacer/>
            <v-layout
              column
            >
              <v-progress-linear
                v-if="loading"
                :indeterminate="true"
                class="progress-radius"
              />
              <v-card
                :class="$vuetify.breakpoint.width < 1200 ? 'login login-card-mobile' : 'login'"
                flat
              >
                <v-stepper v-model="step">
                  <v-stepper-header style="display: none">
                    <v-stepper-step
                      :complete="step > 1"
                      step="1"
                    > Email
                    </v-stepper-step>

                    <v-divider/>

                    <v-stepper-step
                      :complete="step > 2"
                      step="2"
                    >Senha
                    </v-stepper-step>

                  </v-stepper-header>

                  <v-stepper-items>
                    <v-stepper-content step="1">
                      <v-card-title style="text-align: center">{{ strings[idioma].iniciar_sessao }}</v-card-title>
                      
                      <v-layout v-if="$store.state.app.permiteCadastro" wrap flex justify-end>
                        
                        <v-btn v-show="false" small flat @click="login(false, false, true)">
                          <v-icon color="primary">mdi-facebook</v-icon>
                          &nbsp;Login Facebook
                        </v-btn>
                        
                        <v-btn small flat @click="login(false, true)">
                          <v-icon color="red">mdi-google</v-icon>
                          &nbsp;Login Google
                        </v-btn>
                      </v-layout>
                      
                      <v-form
                        ref="form"
                        v-model="valid"
                        :lazy-validation="true"
                        style="padding-top: 24px; padding-bottom: 24px"
                        @submit.prevent="verificaEmail"
                      >

                        <v-text-field
                          v-if="/.+@.+/.test(email) || emailError"
                          ref="email"
                          :rules="emailRules"
                          v-model="email"
                          name="email"
                          label="E-mail"
                          outline
                          prepend-inner-icon="mdi-email"
                          required
                          @focus="verificaErro"
                          @change="verificaErro"
                        />
                        <v-text-field
                          v-else
                          ref="email"
                          v-model="email"
                          name="email"
                          label="E-mail"
                          outline
                          prepend-inner-icon="mdi-email"
                          required
                          @focus="verificaErro"
                          @change="verificaErro"
                        />
                      </v-form>
                      
                      <v-layout
                        :justify-center="$vuetify.breakpoint.xs"
                        :justify-space-between="$vuetify.breakpoint.smAndUp"
                        row
                        wrap
                      >
                        <v-btn
                          v-if="$store.state.app.permiteCadastro"
                          :disabled="loading"
                          flat
                          color="primary"
                          href="signin">
                          {{ strings[idioma].botao_criar_conta }}
                        </v-btn>
                        <v-spacer v-else/>
                        
                        <v-btn
                          :disabled="loading"
                          color="primary"
                          @click="verificaEmail">
                          {{ strings[idioma].botao_seguinte }}
                        </v-btn>
                      </v-layout>

                      
                    </v-stepper-content>

                    <v-stepper-content step="2">
                      <v-card-title style="text-align: center">{{ strings[idioma].login_bem_vindo }}</v-card-title>
                      <div style="width: 100%; text-align: center">
                        <v-chip
                          v-model="chip"
                          close
                        >
                          <v-avatar>
                            <v-icon>mdi-account</v-icon>
                          </v-avatar>
                          {{ email }}
                        </v-chip>
                      </div>
                      <v-form
                        ref="formSenha"
                        v-model="validPassword"
                        :lazy-validation="true"
                        style="padding-top: 0px; padding-bottom: 24px"
                        @submit.prevent="submit"
                      >
                        <v-text-field
                          v-if="verificaoPendente"
                          ref="code"
                          :type="'text'"
                          :label="strings[idioma].codigo_verificacao"
                          :rules="codeRules"
                          v-model="code"
                          mask="####"
                          name="code"
                          outline
                          counter
                          required
                        />
                        <v-text-field
                          v-if="verificaoPendente"
                          ref="password"
                          :rules="passwordRules"
                          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="show1 ? 'text' : 'password'"
                          :label="strings[idioma].placeholder_senha"
                          v-model="password"
                          name="password"
                          outline
                          counter
                          required
                          @click:append="show1 = !show1"
                        />
                        <v-text-field
                          v-if="verificaoPendente"
                          ref="password2"
                          :rules="password2Rules"
                          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="show1 ? 'text' : 'password'"
                          :label="strings[idioma].repita_senha"
                          v-model="password2"
                          name="password2"
                          outline
                          counter
                          required
                          @click:append="show1 = !show1"
                        />
                        <v-text-field
                          v-if="!verificaoPendente"
                          ref="password"
                          :rules="passwordRules"
                          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="show1 ? 'text' : 'password'"
                          :label="strings[idioma].placeholder_senha"
                          v-model="password"
                          name="password"
                          outline
                          counter
                          required
                          @click:append="show1 = !show1"
                          @focus="verificaErroPassword"
                        />
                      </v-form>
                      <v-layout
                        :justify-center="$vuetify.breakpoint.xs"
                        :justify-space-between="$vuetify.breakpoint.smAndUp"
                        row
                        wrap
                      >
                        <div>
                          <v-btn
                            v-show="!verificaoPendente"
                            :disabled="loading"
                            flat
                            small
                            color="primary"
                            style="margin-top: 12px;"
                            @click="esqueci">
                            {{ strings[idioma].esqueceu_senha }}
                          </v-btn>
                          <v-btn
                            v-show="verificaoPendente"
                            :disabled="loading"
                            flat
                            small
                            color="primary"
                            style="margin-top: 12px;"
                            @click="reenviar">
                            {{ strings[idioma].reenviar_codigo }}
                          </v-btn>
                        </div>

                        <vue-recaptcha
                          ref="recaptcha"
                          size="invisible"
                          sitekey="6LdUf7sZAAAAAH7UJA4ROhLha5aC0EoDtdHmcic_"
                          @verify="onCaptchaVerified"
                          @expired="onCaptchaExpired"/>
                        <v-btn
                          :disabled="loading"
                          class="g-recaptcha"
                          color="primary"
                          @click="submit">
                          {{ strings[idioma].botao_entrar }}
                        </v-btn>
                      </v-layout>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-card>
            </v-layout>
          </v-flex>

          <ContentDescription v-if="exibeConteudoApresentacao"/>
        </v-layout>
        <Footer/>
      </v-container>
    </v-layout>
  </v-container>

</template>

<style scoped>
.login-text{
  padding-top: 100px;

  overflow: auto;
}
.login-text div{
  -webkit-filter: blur(0px);
  -moz-filter: blur(0px);
  -o-filter: blur(0px);
  -ms-filter: blur(13px);
  filter: blur(0px);

  -webkit-backdrop-filter: blur(2px); /* Safari 9+ */
  backdrop-filter: blur(2px); /* Chrome and Opera */

  overflow: auto;
}
.login-content{
  -webkit-filter: blur(0px);
  -moz-filter: blur(0px);
  -o-filter: blur(0px);
  -ms-filter: blur(13px);
  filter: blur(0px);
  max-height: 700px; overflow: auto;
  overflow-y: hidden;
  overflow-x: hidden;
  opacity: 0.7;
  transition: opacity 2s;
  -webkit-backdrop-filter: blur(2px); /* Safari 9+ */
  backdrop-filter: blur(2px); /* Chrome and Opera */
}
.login-content:hover{
  transition: opacity 2s;
  opacity: 1;
}
.login-card-mobile {
  padding: 0px;
  margin: 0px;
}
</style>

<script>
import VueRecaptcha from 'vue-recaptcha'
import { EMPRESA_TIPOS } from '../utils/types'
import Footer from './components/FreePages/Footer'
import ContentDescription from './components/FreePages/ContentDescription.vue'
import LeftLogo from './components/FreePages/LeftLogo.vue'
import { getAuth } from 'firebase/auth'
import { signInWithPopup,GoogleAuthProvider, FacebookAuthProvider } from "firebase/auth";
import {
  mapState
} from 'vuex'
export default {
  components: {
    VueRecaptcha,
    Footer,
    ContentDescription,
    LeftLogo
  },
  data () {
    return {
      background: 'img/drawer-bg.jpg',
      chip: true,
      code: null,
      codeError: false,
      codeErrorMessage: null,
      EMPRESA_TIPOS: EMPRESA_TIPOS,
      email: null,
      emailError: false,
      emailErrorMessage: null,
      emailRules: [
        v => !!v || this.strings[this.idioma].email_obrigatorio,
        v => /.+@.+/.test(v) || this.strings[this.idioma].email_invalido,
        v => {
          if (this.emailError) {
            return this.strings[this.idioma].email_invalido
          }
          return false
        }
      ],
      loading: false,
      logando: false,
      // logo: 'img/brcorte-logo.png',
      // img/br-corte-logobranca.png
      password: null,
      passwordRules: [
        value => !!value || this.strings[this.idioma].senha_obrigatorio,
        value => {
          if (this.passwordError) {
            return this.passwordErrorMessage
          }
          return false
        }
      ],
      codeRules: [
        v => !!v || this.strings[this.idioma].codigo_obrigatorio,
        value => {
          if (this.codeError) {
            return this.codeErrorMessage
          }
          return false
        }
      ],
      password2: null,
      password2Rules: [
        value => (this.password !== value) && this.strings[this.idioma].senhas_nao_batem,
        value => !!value || this.strings[this.idioma].senha_obrigatorio,
        value => {
          if (this.passwordError) {
            return this.passwordErrorMessage
          }
          return false
        }
      ],
      show1: false,
      step: 1,
      valid: null,
      validPassword: null,
      verificaoPendente: false,
      intervalGoogle: 0
    }
  },
  computed: {
    ...mapState('app', ['strings', 'idioma', 'user', 'token', 'curr_version', 'categorias_alimentos', 'links_', 'empresa', 'exibeConteudoApresentacao']),
    heightOverflow () {
      return 'margin: 0; padding: 20px; max-height: ' + String(this.$vuetify.breakpoint.height) + 'px; overflow: auto;'
    }
  },
  watch: {
    'chip' (val) {
      if (!val) {
        this.step = 1
        this.$refs.form.reset()
        this.$refs.formSenha.reset()
        this.chip = true
      }
      if (this.logando) {
        this.chip = true
      }
    },
    'step' (val) {
      if (parseInt(val) === 1) {
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.$nextTick(() => this.$refs.email.focus())
          })
        })
      } else {
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.$nextTick(() => this.$refs.password.focus())
          })
        })
      }
    },
    'password' (val) { this.passwordError = false },
    'idioma' (val) {
      this.$refs.formSenha.validate()
      this.$refs.email.validate()
      window.location.reload(true)
    }
  },
  mounted () {
    if (this.$route.query.lang) {
      this.$store.commit('setIdioma', this.$route.query.lang === 'br' ? 0 : 1)
    }
    this.$nextTick(() => this.$refs.email.focus())
    let backgrounds = ['img/background-bois.jpg', 'img/gado-background.jpg', 'img/background-login.jpg', 'img/Ocasião_da_SH_e_Batuque_do_R.I..jpg', 'img/IMG-20180329-WA0001.jpg', 'img/IMG-20180330-WA0012.jpg', 'img/IMG-20181118-WA0008.jpg']
    this.background = backgrounds[parseInt((Math.random() * 100)) % backgrounds.length]
  },
  methods: {
    async loginGoogle (onResponse = () => {}) {
      //initialize firebase auth
      const provider = new GoogleAuthProvider();
      return signInWithPopup(getAuth(), provider)
        .then((result) => {
          var email = result.user.email
          var emailVer = result.user.emailVerified
          var name = result.user.displayName
          var accessToken = result.user.accessToken
          var uid = result.user.uid
          onResponse({ email: email, emailVer, nome: name, accessToken, uid, loginGoogle: true })
        })
        .catch((err) => {
          console.log(err); // This will give you all the information needed to further debug any errors
        });
    },
    async loginFacebook (onResponse = () => {}) {
      //initialize firebase auth
      const provider = new FacebookAuthProvider();
      return signInWithPopup(getAuth(), provider)
        .then((result) => {
          console.log({ result })
          var email = result.user.email
          var emailVer = result.user.emailVerified
          var name = result.user.displayName
          var accessToken = result.user.accessToken
          var uid = result.user.uid
          onResponse({ email: email, emailVer, nome: name, accessToken, uid, loginGoogle: true })
        })
        .catch((err) => {
          console.log(err); // This will give you all the information needed to further debug any errors
        });
    },
    get () {
      return this.axios.post('consultoria/clientes', { id: this.user.consultoria.id }).then(r => {
        this.clientes = r.data.data
        let cliente = JSON.parse(localStorage.getItem('cliente'))
        if (cliente && cliente !== null) this.cliente = cliente.id
      })
    },
    reenviar () {
      this.axios.post('auth/enviaCodigo', { email: this.email }).then(r => {
        let msg = (this.strings[this.idioma].enviado).format(this.email)
        let time = 6000
        this.$store.commit('openSuccessAlert', { msg, time })
      })
    },
    loadDashboard () {
      this.$store.commit('getLinks')
      this.$router.push('/dashboard')
    },
    submit () {
      // this.status = "submitting";

      if (process.env.VUE_APP_PRODUCTION === true) {
        console.log('deu ruim 1')
        this.$refs.recaptcha.execute()
      } else {
        this.login()
      }
      // let count = 0
      // this.intervalGoogle = setInterval(() => {
      //   count++
      //   if (count > 10) {
      //     clearInterval(this.intervalGoogle)
      //     this.login()
      //   }
      // }, 100)
    },
    onCaptchaVerified (recaptchaToken) {
      const self = this
      self.$refs.recaptcha.reset()
      if (recaptchaToken !== '' || recaptchaToken !== null) clearInterval(this.intervalGoogle)
      self.login()
    },
    onCaptchaExpired () {
      clearInterval(this.intervalGoogle)
      this.$refs.recaptcha.reset()
    },
    login_ (reset = true) {
      const empresaGetData = (r) => {
        return this.axios.post('empresa/getAcesso', {}).then(r => {
          if (r.data.data.empresa.EXCLUIDO) {
            this.$store.commit('setEmpresa', null)
            localStorage.setItem('empresa', JSON.stringify(null))
          } else {
            this.$store.commit('setEmpresa', r.data.data.empresa)
            localStorage.setItem('empresa', JSON.stringify(r.data.data.empresa))
          }
          if (this.user.NOME === '' || this.user.NOME === null || this.user.endereco === null || !this.user.endereco.cidade || (this.user.endereco.cidade && this.user.endereco.cidade === '')) {
            window.location.href = '/user'
            return
          }
          // this.login(false)
          this.loadDashboard()
        }).catch(() => {
          this.$store.commit('setEmpresa', null)
          localStorage.setItem('empresa', JSON.stringify(null))
          if (this.user.NOME === '' || this.user.NOME === null || this.user.endereco === null || !this.user.endereco.cidade || (this.user.endereco.cidade && this.user.endereco.cidade === '')) {
            window.location.href = '/user'
            return
          }
          this.loadDashboard()
        })
        //
      }
      this.$store.commit('resetStates')
      let tokenSalvo = localStorage.getItem('user-token')
      if (tokenSalvo && tokenSalvo !== null) return
      if (reset) {
        this.$limpaLocalStorage()
        localStorage.setItem('version', this.curr_version)
        this.$refs.formSenha.validate()
      }
      if (this.validPassword) {
        if (this.verificaoPendente) {
          this.axios.post('auth/verificaCodeCadastro', { email: this.email, code: this.code }).then(response => {
            this.axios.post('auth/cadastraSenha', { email: this.email, password: this.password, new_password: this.password }).then(uresponse => {
              this.loading = false
              let msg = this.strings[this.idioma].verificado_com_sucesso
              let time = 6000
              this.$store.commit('openSuccessAlert', { msg, time })
              localStorage.setItem('user-token', uresponse.data.data.token)
              localStorage.setItem('user', JSON.stringify(uresponse.data.data.user))
              this.$store.commit('setUser', uresponse.data.data.user)
              this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + uresponse.data.data.token
              empresaGetData().then(_ => {
                this.$router.push('/dashboard')
                if ((this.user && (this.user.NOME === null || (this.user.NOME).trim() === '')) ||
                  (this.user && this.user.endereco && this.user.endereco.cidade && (this.user.endereco.cidade === null || (this.user.endereco.cidade).trim() === ''))) {
                  window.location.href = '/user'
                }
              }).catch(_ => {
                this.$router.push('/dashboard')
                if ((this.user && (this.user.NOME === null || (this.user.NOME).trim() === '')) ||
                  (this.user && this.user.endereco && this.user.endereco.cidade && (this.user.endereco.cidade === null || (this.user.endereco.cidade).trim() === ''))) {
                  window.location.href = '/user'
                }
              })

              // window.location.href = '/'
              this.verificaoPendente = false
            }).catch(err => {
              let msg = this.strings[this.idioma].problema_de_comunicacao
              let time = 6000
              this.$store.commit('openErrorAlert', { msg, time })
              console.log(err)
            })
          }).catch(err => {
            let msg = this.strings[this.idioma].codigo_verificao_incorreta
            let time = 6000
            this.$store.commit('openErrorAlert', { msg, time })
            console.log(err)
          })
        } else {
          this.loading = true
          this.axios.post('auth/appLogin', { email: this.email, password: this.password }).then(response => {
            this.loading = false
            localStorage.setItem('user-token', response.data.data.token)
            localStorage.setItem('user', JSON.stringify(response.data.data.user))
            localStorage.setItem('sessoes', JSON.stringify(response.data.data.sessoes))
            this.$store.commit('setUser', response.data.data.user)
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.data.token

            this.axios.post('auth/getPendenciasVinculo', {}).then(r => {
              if (
                (this.user.emp_user) &&
                (
                  (this.user.emp_user !== null && this.user.emp_user.supervisor && this.user.emp_user.supervisor !== null && parseInt(this.user.emp_user.supervisor.autorizado) === 0) ||
                  (this.user.emp_user !== null && parseInt(this.user.emp_user.lido) === 0)
                )
              ) {
                this.$store.commit('setEmpresa', null)
                localStorage.setItem('empresa', JSON.stringify(null))
                r.data.data.empresa = null
                this.$router.push('/dashboard')
                this.loadDashboard()
                return
              }
              if (r.data.data.length > 0) {
                sessionStorage.setItem('dependeAprovacao', true)
                this.$confirm(this.$store.state, this.strings[this.idioma].aceito_vinculo.format(r.data.data[0].empresa.nome + ' - ' + this.strings[this.idioma][EMPRESA_TIPOS[r.data.data[0].acesso]])).then(r => {
                  sessionStorage.setItem('dependeAprovacao', false)
                  this.axios.post(r === 'nao' ? 'auth/reprovarVinculo' : 'auth/aprovarVinculo', {}).then((res) => {
                    // this.login()
                    empresaGetData(r).then(_ => {
                      this.$router.push('/dashboard')
                    })
                  })
                  empresaGetData(r).then(r => {
                    this.$router.push('/dashboard')
                    if (this.user.NOME === '' || this.user.NOME === null || this.user.endereco === null || !this.user.endereco.cidade || (this.user.endereco.cidade && this.user.endereco.cidade === '')) {
                      window.location.href = '/user'
                      return
                    }
                    this.loadDashboard()
                  })
                  //
                }).catch((ex) => {
                  console.log(ex)
                })
              } else {
                empresaGetData(r).then(r => {
                  this.$router.push('/dashboard')
                  if (this.user.NOME === '' || this.user.NOME === null || this.user.endereco === null || !this.user.endereco.cidade || (this.user.endereco.cidade && this.user.endereco.cidade === '')) {
                    window.location.href = '/user'
                    return
                  }
                  this.loadDashboard()
                })
              }
            })
          }).catch(_ => {
            this.loading = false
            this.passwordError = true
            this.passwordErrorMessage = this.strings[this.idioma].senha_nao_valida
            this.$refs.formSenha.validate()
          })
        }
      }
    },
    async login (reset = true, google = false, facebook = false) {
      const loginAction = async ({ email, password }) => {
        let params = {}
        params['lat'] = localStorage.getItem('lat')
        params['lon'] = localStorage.getItem('lon')
        let clientTokenFirebase = localStorage.getItem('clientToken') ? localStorage.getItem('clientToken') : null
        
        const response = await this.axios.post('auth/appLogin', { email, password, clientTokenFirebase, ...params })
        return response
      }
      const loginJob = async (res = null) => {
        try {
          if (res === null) res = await loginAction({ email: this.email, password: this.password })

          localStorage.setItem('user-token', res.data.data.token)
          localStorage.setItem('user', JSON.stringify(res.data.data.user))
          localStorage.setItem('sessoes', JSON.stringify(res.data.data.sessoes))

          this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + res.data.data.token

          this.$store.commit('resetStates')
          this.$store.commit('setUser', res.data.data.user)
          try {
            await getAcesso(res.data.data.user)
            console.log({ empresa: this.empresa })
          } finally {
            this.$store.commit('getLinks')
            setTimeout(() => { this.loadDashboard() }, 100)
            this.loading = false
          }
        } catch (e) {
          console.log({ e })
          this.loading = false
          this.passwordError = true
          this.passwordErrorMessage = this.strings[this.idioma].senha_nao_valida
          this.$refs.formSenha.validate()
        }
      }
      const verificacao = async () => {
        await Promise.all([
          this.axios.post('auth/verificaCodeCadastro', { email: this.email, code: this.code }),
          this.axios.post('auth/cadastraSenha', { email: this.email, password: this.password, new_password: this.password })
        ])
      }
      const verificacaoCode = async () => {
        await this.axios.post('auth/verificaCodeCadastro', { email: this.email, code: this.code })
      }
      const verificacaoSenha = async () => {
        await this.axios.post('auth/cadastraSenha', { email: this.email, password: this.password, new_password: this.password })
      }
      const getAcesso = async (user, callback = null) => {
        const res = await this.axios.post('empresa/getAcesso', {}).then(
          r => {
            this.$store.commit('setEmpresa', r.data.data.empresa)
            localStorage.setItem('empresa', JSON.stringify(r.data.data.empresa))
            this.$store.commit('setUser', user)

            if (callback !== null) callback(r, user)
          })
        return res
      }
      if (google) {
        return this.loginGoogle((res) => {
          this.axios.post('auth/appLogin', res).then(async (res) => {
            await loginJob(res)
          })
        })
      }
      if (facebook) {
        return this.loginFacebook((res) => {
          this.axios.post('auth/appLogin', res).then(async (res) => {
            await loginJob(res)
          })
        })
      }
      let tokenSalvo = localStorage.getItem('user-token')
      if (tokenSalvo && tokenSalvo !== null) return
      if (!this.validPassword) return
      if (reset) {
        this.$limpaLocalStorage()
        localStorage.setItem('version', this.curr_version)
        this.$refs.formSenha.validate()
      }
      this.loading = true
      if (!this.verificaoPendente) {
        await loginJob()
      } else {
        try {
          await verificacaoCode()
        } catch (e) {
          this.loading = false
          this.codeError = true
          this.codeErrorMessage = this.strings[this.idioma].codigo_verificao_incorreta
          this.$refs.formSenha.validate()
          return
        }
        try {
          await verificacaoSenha()
        } catch (e) {
          this.loading = false
          this.passwordError = true
          this.passwordErrorMessage = this.strings[this.idioma].codigo_verificao_incorreta
          this.$refs.formSenha.validate()
          return
        }
        if (!this.passwordError) await loginJob()
      }
    },
    esqueci () {
      this.loading = true
      this.axios.post('/auth/esqueciSenha', { email: this.email }).then(response => {
        this.loading = false
        let msg = (this.strings[this.idioma].enviado).format(this.email)
        let title = this.strings[this.idioma].esqueceu_senha
        this.$store.commit('openOKModal', { title, msg })
      }).catch(reason => {
        this.loading = false
        let msg = this.strings[this.idioma].usuario_nao_encontrado
        let time = 6000
        this.$store.commit('openErrorAlert', { msg, time })
      })
    },
    verificaEmail () {
      this.$refs.form.validate()

      if (this.valid) {
        this.email = this.email.toLowerCase()
        this.loading = true
        this.axios.post('/auth/verificaEmail', { email: this.email }).then(response => {
          this.loading = false
          this.verificaoPendente = false
          this.step = 2
        }).catch(error => {
          if (error.response.status === 403 || error.response.status === 402) {
            this.loading = false
            this.emailError = false
            this.step = 2
            this.verificaoPendente = true
          } else {
            this.loading = false
            this.emailError = true
            this.emailErrorMessage = error
            this.$refs.form.validate()
          }
        })
      }
    },
    verificaErro () {
      if (this.email === '' || this.emailError) {
        this.emailError = false
        // this.emailErrorMessage = this.strings[this.idioma].email_invalido
        this.$refs.form.validate()
      }
    },
    verificaErroPassword () {
      if (this.passwordError) {
        this.passwordError = false
        this.passwordErrorMessage = null
        this.$refs.formSenha.validate()
      }
    }
  }
}
</script>
